import { RequestModes, RequestCriteria } from '../RequestCriteria.js';
import { OnsiteVisit } from '../OnsiteVisit.js';

function OnsiteService($http, $interval, $location, $q, $resource) {

    var self = this,
        onsiteTemplate = {
            templateName: "OnSite",
            phoneNumber: "PhoneNumber",
            siteCode: "SiteCode",
            siteName: "SiteName",
            userName: "UserName",
            timeIn: "TimeIn",
            timeOut: "TimeOut"
        },

        notesResource = $resource('/api/notes/:id', {
            id: "@id",
            logId: "@logId"
        }, { query: {
                method: "GET", isArray: false, params: {
                    size: 1000000,
                    projection: "noteProjectionOnsite",
                    templateName: onsiteTemplate.templateName
                },
                noErrorPopup: true
            }
         }, {
            cancellable: true
        }),

        noteCommentsResource = $resource('/api/noteComments/:commentId', { commentId: null }, {
            query: {method: "GET", isArray: false, params: {
                projection: "noteCommentProjectionOnsite"
            }, noErrorPopup: true }
        }),

        noteTemplateValueResource = $resource('/api/noteTemplateValues/:id', {id: null}, {
            query: {method: "GET", isArray: false, noErrorPopup: true}
        }),

        onsiteContactsResource = $resource('/api/onsiteContacts/:id', {id: null}, {
            query: {method: "GET", isArray: false},
            patchUpdate: {method: "PATCH"}
        }),

        templateResource = $resource("/api/templates", {name: onsiteTemplate.templateName}, {
            query: {method: "GET", isArray: false}
        }),

        templateSegmentResource = $resource("/api/templateSegments", {templateId: "@id"}, {
            query: {method: "GET", isArray: false}
        }),

        tagsResource = $resource("/api/tagValues", {logId: "@id"}, {
            query: {method: "GET", isArray: false}
        });

    function getSearchQuery(searchTerm, activeOnly) {
        var searchQuery = "";

        if (searchTerm) {
            var searchTermWords = searchTerm.split(' ');

            for (var i = 0; i < searchTermWords.length; i++) {
                if (i > 0) {
                    searchQuery += ' and ';
                }
                searchQuery += 'note =hasTemplateValue=("string_value == *' + searchTermWords[i] + '*")';
            }
        }

        if (activeOnly) {
            if (searchQuery) {
                searchQuery += ' and ';
            }
            searchQuery += 'note =hasNoTemplateValue=("TimeOut", "datetime_value != null")';
        }

        return searchQuery;
    }

    this.getComments = function (logId, reportId, page) {
        var canceller = $q.defer(),
            params = {
                "note.logId": logId,
                "note.templateName": "OnSite",
                report: reportId,
                page: page || 0,
                projection: "noteCommentProjectionOnsite",
                size: 10,
                sort: "created,desc"
            },
            promise = $http.get('/api/noteComments', {
                noErrorPopup: true,
                params: params,
                noIndicator: true,
                timeout: canceller.promise
            });

        promise.cancel = function () {
            canceller.promise.suppressErrorFlag = true;
            canceller.resolve();
            return canceller.promise;
        };

        return promise;
    };


    this.getVisits = function (requestCriteria) {
        var canceller = $q.defer(),
            params = {
                logId: requestCriteria.logId,
                report: requestCriteria.report,
                page: requestCriteria.page,
                projection: "noteProjectionOnsite",
                size: requestCriteria.size,
                sort: requestCriteria.sort,
                templateName: onsiteTemplate.templateName,
                fromDate: requestCriteria.startDate instanceof moment ? requestCriteria.startDate.toDate() : null,
                thruDate: requestCriteria.endDate instanceof moment ? requestCriteria.endDate.toDate() : null
            },
            promise;

        if (requestCriteria.searchTerm || requestCriteria.activeOnly) {
            params.templateValueQuery = getSearchQuery(requestCriteria.searchTerm, requestCriteria.activeOnly);
        }

        if (requestCriteria.mode === RequestModes.UPDATE) {
            params.fromDate = null;
            params.thruDate = null;
            params.updatedFromDate = moment(requestCriteria.latest.toISOString()).subtract(1, 'minute').toDate();
        } else {
            params.fromDate = requestCriteria.startDate instanceof moment ? requestCriteria.startDate.toDate() : null;
            params.thruDate = requestCriteria.endDate instanceof moment ? requestCriteria.endDate.toDate() : null;
        }

        promise = $http.get('/api/notes', {
            noErrorPopup: true,
            params: params,
            noIndicator: true,
            timeout: canceller.promise
        });

        promise.cancel = function () {
            canceller.promise.suppressErrorFlag = true;
            canceller.resolve();
            return canceller.promise;
        };

        return promise;
    };

    this.getVisit = function(visitId){
        var deferred = $q.defer();
        notesResource.get({id: visitId, projection: "noteProjectionOnsite"}).$promise.then(function(note){
            deferred.resolve(note);
        });

        return deferred.promise;
    };

    this.addVisit = function (visit) {

        var deferred = $q.defer(),
            baseUrl = $location.absUrl().split("#")[0];

        var criteria = new RequestCriteria(visit.logId);
        criteria.activeOnly = true;

        self.getVisits(criteria).then(function (data) {
            var existingVisit = data.data._embedded.notes.map(function (lbNote) {
                return new OnsiteVisit(lbNote);
            }).find(function (activeVisit) {
                return visit.phoneNumber === activeVisit.phoneNumber;
            });

            if (existingVisit) {
                self.checkOutContact(existingVisit);
            }
        
            // Get the template.
            templateResource.get().$promise.then(function (templateResponse) {
                var templateRef = templateResponse._embedded.templates[0]._links.self.href;
                var templateId = templateResponse._embedded.templates[0].id;

                // Get the templateSegments.
                templateSegmentResource.query({templateId: templateId}).$promise.then(function (tsResponse) {
                    var noteTemplateValues = tsResponse._embedded.templateSegments.map(function (segment) {
                        switch (segment.name) {
                            case onsiteTemplate.phoneNumber: {
                                return {
                                    templateSegmentId: segment.id,
                                    stringValue: visit.phoneNumber
                                };
                            }
                            case onsiteTemplate.userName: {
                                return {
                                    templateSegmentId: segment.id,
                                    stringValue: visit.userName
                                };
                            }
                            case onsiteTemplate.siteCode: {
                                return {
                                    templateSegmentId: segment.id,
                                    stringValue: visit.site.siteId
                                };
                            }

                            case onsiteTemplate.siteName: {
                                return {
                                    templateSegmentId: segment.id,
                                    stringValue: visit.site.siteName
                                };
                            }
                            case onsiteTemplate.timeIn: {
                                return {
                                    templateSegmentId: segment.id,
                                    dateTimeValue: visit.timeIn
                                };
                            }
                        }
                    }).filter(function (item) {
                        return item != null;
                    });


                    var visitNote = {
                        log: baseUrl + '/api/logs/' + visit.logId,
                        newAttachments: [],
                        note: " ",
                        draft: false,
                        noteTemplateValues: noteTemplateValues,
                        noteTime: 'now',
                        removeAttachments: [],
                        template: templateRef,
                        tagValues: [(baseUrl + '/api/tagValues/' + visit.site.id)]
                    };

                    notesResource.save(visitNote).$promise.then(function (response) {

                        noteCommentsResource.save({
                            note: response._links.self.href,
                            comment: "Site Visit Manually Created"
                        }).$promise.then(function(){
                            notesResource.get({id: response.id, projection: "noteProjectionOnsite"}).$promise.then(function(note){
                                deferred.resolve(note);
                            });
                        });
                    });
                });
            });
        });
        return deferred.promise;
    };

    this.checkOutContact = function (visit) {
        var deferred = $q.defer();
        templateResource.query().$promise.then(function (data) {
            var templateId = data._embedded.templates[0].id;
            templateSegmentResource.query({templateId: templateId}).$promise.then(function (segData) {

                var segment = segData._embedded.templateSegments.find(function (seg) {
                    return seg.name === onsiteTemplate.timeOut;
                });

                noteTemplateValueResource.save({
                    noteId: visit.noteId,
                    note: visit.noteHref,
                    dateTimeValue: new Date(),
                    templateSegmentId: segment.id,
                    templateSegment: segment._links.self.href
                }).$promise.then(function () {
                    noteCommentsResource.save({
                        note: visit.noteHref,
                        comment: "Manual Check Out"
                    }).$promise.then(function () {
                        deferred.resolve();
                    });
                });
            });
        });
        return deferred.promise;
    };


    this.getAvailableSites = function (logId) {
        var sitesReq = $q.defer();

        tagsResource.query({
            logId: logId,
            stringValue: onsiteTemplate.templateName
        }).$promise.then(function (data) {
            tagsResource.query({
                logId: logId,
                parents: data._embedded.tagValues[0].id
            }).$promise.then(function (siteTags) {
                sitesReq.resolve(siteTags._embedded.tagValues.map(function (siteTag) {
                    return {
                        id: siteTag.id,
                        siteId: siteTag.stringValue,
                        siteName: siteTag.description
                    };
                }));
            });
        });

        return sitesReq.promise;
    };

    this.getKnownUsers = function (logId) {
        return onsiteContactsResource.query({forLogId: logId}).$promise;
    };

    this.undoCheckoutContact = function (visit) {
        var deferred = $q.defer();
        noteTemplateValueResource.query({
            noteId: visit.noteId,
            templateSegmentName: onsiteTemplate.timeOut
        }).$promise.then(function (data) {
            var ntv = data._embedded.noteTemplateValues.find(function (val) {
                return val.templateSegmentName === onsiteTemplate.timeOut;
            });

            noteTemplateValueResource.remove({id: ntv.id}).$promise.then(function () {
                noteCommentsResource.save({
                    noteId: visit.noteId,
                    note: visit.noteHref,
                    comment: "Check Out Removed"
                }).$promise.then(function () {
                    deferred.resolve();
                });
            });
        });
        return deferred.promise;
    };
}

angular.module("onsite").service("onsiteService", ["$http", "$interval", "$location", "$q", "$resource", OnsiteService]);
